import { Component, EventEmitter, Input, OnInit, Output, OnDestroy, ChangeDetectionStrategy } from "@angular/core";
import { RoutinesOptimizationService } from "src/app/services/routines-optimization.service";
import { Subject, of } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-routines-table",
  templateUrl: "./routines-table.component.html",
  styleUrls: ["./routines-table.component.css"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoutinesTableComponent implements OnInit, OnDestroy {
  @Input() headers: string[] = [];
  @Input() data: any[][] = [];
  @Input() itemsPerPage: number = 5;
  @Output() edit = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();

  currentPage: number = 1; // Página atual
  paginatedData: any[][] = []; // Dados paginados
  totalPages: number = 1; // Total de páginas

  searchQuery: string = ""; // Termo de busca
  selectedJobTitle: string = ""; // Cargo selecionado para filtro

  filteredData: any[][] = []; // Dados filtrados para a busca e filtro
  isLoading: boolean = false; // Estado de loading
  private destroy$ = new Subject<void>(); // Subject para cleanup

  @Input() isAdmin: boolean;
  @Input() isSupervisor: boolean;
  @Input() isManager: boolean;
  @Input() isUser: boolean;

  constructor(private routinesOptimization: RoutinesOptimizationService) {}

  ngOnInit(): void {
    this.filteredData = this.data;
    this.calculatePagination();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // Método para calcular a paginação
  calculatePagination() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.paginatedData = this.filteredData.slice(startIndex, endIndex);
    this.totalPages = Math.ceil(this.filteredData.length / this.itemsPerPage);
  }

  // Método para mudar de página
  changePage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.calculatePagination();
    }
  }

  // Método de busca otimizado com debounce
  search() {
    this.routinesOptimization.search(this.searchQuery);
  }

  // Método para filtrar por Cargo
  filterByJobTitle() {
    this.filterData();
  }

  /**
   * Método otimizado para realizar a busca
   */
  private performSearch(query: string): any[][] {
    const lowerQuery = query.toLowerCase();
    return this.data.filter((row) => {
      const matchesSearch = row.some((col) => col.toString().toLowerCase().includes(lowerQuery));
      const matchesJobTitle = this.selectedJobTitle ? row.includes(this.selectedJobTitle) : true;
      return matchesSearch && matchesJobTitle;
    });
  }

  // Método para aplicar os filtros de busca e cargo
  filterData() {
    const query = this.searchQuery.toLowerCase();
    this.filteredData = this.performSearch(query);
    this.currentPage = 1; // Resetar para a primeira página ao filtrar
    this.calculatePagination();
  }

  onEdit(row: any) {
    this.edit.emit(row);
  }

  onDelete(row: any) {
    this.delete.emit(row);
  }

  getUniqueJobTitles(): string[] {
    const jobIndex = this.headers.indexOf("Cargo");
    if (jobIndex === -1) return [];

    const jobs = this.data.map((row) => row[jobIndex]);
    return [...new Set(jobs)]; // Remove duplicatas
  }
}
